// Final Sale note manager for Minimog cart drawer
// - Waits for DOM ready
// - Looks for visible .tag-cart-container#finalsaledrawer that displays the Final Sale text
// - Inserts a single note container inside #MinimogCartDrawerFooter when present
// - Removes the container when no qualifying elements exist
// - Observes DOM mutations to keep the UI in sync

document.addEventListener('DOMContentLoaded', function () {
  var FOOTER_SELECTOR = '#MinimogCartDrawerFooter';
  var FINAL_SALE_SELECTOR = '.tag-cart-container#finalsaledrawer';
  var NOTE_CONTAINER_ID = 'finalSaleNoteContainer';
  var NOTE_HTML = '' +
    '<div class="finalNote">' +
    "Note: Items that are marked 'Final sale' or International Orders are not eligible for returns and exchanges." +
    '</div>';

  // Returns a list of nodes that match the Final Sale indicator and are visibly displayed
  function getVisibleFinalSaleNodes() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(FINAL_SALE_SELECTOR));

    return nodes.filter(function (node) {
      try {
        var style = window.getComputedStyle(node);
        if (!style) return false;

        // Treat display none or hidden as not visible
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
          return false;
        }

        // Ensure the content is the specific Final Sale message
        var text = (node.textContent || '').trim().toLowerCase();
        return text.indexOf('final sale - no returns, exchanges, or refunds') !== -1;
      } catch (err) {
        return false;
      }
    });
  }

  // Ensures the note container exists in the footer. Returns true if appended or already present.
  function ensureNoteInFooter() {
    var footer = document.querySelector(FOOTER_SELECTOR);
    if (!footer) return false;

    var existing = footer.querySelector('#' + NOTE_CONTAINER_ID);
    if (existing) return true;

    var container = document.createElement('div');
    container.id = NOTE_CONTAINER_ID;
    container.innerHTML = NOTE_HTML;

    // Append at the end of the footer. If you prefer it at the top, use footer.prepend(container)
    footer.appendChild(container);
    return true;
  }

  // Removes the note container from the footer if present
  function removeNoteFromFooter() {
    var footer = document.querySelector(FOOTER_SELECTOR);
    if (!footer) return;

    var existing = footer.querySelector('#' + NOTE_CONTAINER_ID);
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
  }

  // Main updater: add or remove note based on current Final Sale indicators
  function updateFinalSaleNote() {
    var hasFinalSale = getVisibleFinalSaleNodes().length > 0;
    if (hasFinalSale) {
      ensureNoteInFooter();
    } else {
      removeNoteFromFooter();
    }
  }

  // Initial run
  updateFinalSaleNote();

  // Observe mutations to keep the note in sync with dynamic cart drawer updates
  var updateTimer = null;
  function scheduleUpdate() {
    if (updateTimer !== null) return;
    updateTimer = window.setTimeout(function () {
      updateTimer = null;
      updateFinalSaleNote();
    }, 50); // small debounce to avoid excessive recalculations
  }

  // Prefer observing the cart drawer if present, otherwise fall back to body
  var observeTarget = document.querySelector('#MinimogCartDrawer') || document.body;

  try {
    var observer = new MutationObserver(function () {
      scheduleUpdate();
    });

    observer.observe(observeTarget, {
      childList: true,
      attributes: true,
      subtree: true
    });
  } catch (e) {
    // Fallback: if MutationObserver isn't supported, poll periodically
    window.setInterval(updateFinalSaleNote, 500);
  }

  // Also run on visibility changes which may be triggered by drawer open/close
  document.addEventListener('visibilitychange', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate);
});